import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const NotificationContext = createContext({ unread: 0, pendingAccess: 0, poPlaceAlerts: 0, refresh: () => {} });

// Single shared poller for the notification-bell unread count and the Access-Requests nav
// badge — avoids two independent 30s intervals fetching overlapping data, and exposes
// `refresh()` so any screen that resolves a notification/request can force an instant update.
export const NotificationProvider = ({ children }) => {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);
  const [pendingAccess, setPendingAccess] = useState(0);
  const [poPlaceAlerts, setPoPlaceAlerts] = useState(0);

  const refresh = useCallback(() => {
    if (!user) return;
    api.get("/notifications").then((r) => setUnread(r.data.filter((n) => !n.read).length)).catch(() => {});
    api.get("/access-requests/count").then((r) => setPendingAccess(r.data.count)).catch(() => {});
    api.get("/alerts/po-place-count").then((r) => setPoPlaceAlerts(r.data.count)).catch(() => {});
  }, [user]);

  useEffect(() => {
    if (!user) { setUnread(0); setPendingAccess(0); setPoPlaceAlerts(0); return; }
    refresh();
    const iv = setInterval(refresh, 30000);
    return () => clearInterval(iv);
  }, [user, refresh]);

  return (
    <NotificationContext.Provider value={{ unread, pendingAccess, poPlaceAlerts, refresh }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
